const SetupData = {
    mapAPIkey: ["AIza-no-longer-in-used"],
    mapLanguage: ["en"],
    mapRegion: ["MY"],
    property: {
        // categories: ['Commercial', 'Residential'],
        // types: ['Apartment', 'Flat', 'Condominium', 'Serviced Residence', '1-sty Terrace/Link House', '2-sty Terrace/Link House',
        //     '3-sty Terrace/Link House', '4-sty Terrace/Link House', '2 & 3 Sty Terrace/Link House', '1.5-sty Terrace/Link House',
        //     '2.5-sty Terrace/Link House', '3.5-sty Terrace/Link House', '4.5-sty Terrace/Link House', 'Double Storey Superlink Homes',
        //     '3 Storey Superlink Homes', 'Townhouse', 'Cluster House', "Bungalow", 'Bungalow Land', 'Semi-detached House', 'Villa',
        //     '3 Storey Semi-detached Homes', 'Residential Land', 'Office', 'Shop', 'Shop Office', 'Retail Office', 'Retail Space', 'SOFO',
        //     'SOHO', 'SOVO', 'Commercial Bungalow', 'Commercial Semi-D', 'Designer Suites', 'Business Center', 'Hotel/Resort', 'Commercial Land',
        //     'Suites', 'Luxury Suites', 'Factory', 'Semi-D Factory', 'Detached Factory', 'Link Factory', 'Warehouse', 'Light Industrial', 'Industrial Land',
        //     'Agricultural Land'],
        unitTypes: ['Corner', 'Duplex', 'Endlot', 'Intermediate', 'Penthouse', 'SOHO', 'Studio', 'Triplex', 'Unknown'],
        // titles: ['Aparment/Flat', 'Condo/Serviced Residence', 'SOHO', "SOVO", "Semi-D/Bungalow", "Terrace/Link/Townhouse", "Residential Land",
        //     "Shop/Office/Retail Space", "Hotel/Resort", "Commercial Land", "Suites", "Luxury Suites", "Factory/Warehouse", "Industrial Land",
        //     "Agricultural Land"],
        tenures: ['Freehold', 'Leasehold', 'Lease Tenancy', 'Malay Reserved Land', 'Unknown'],
        furnishings: ['Fully Furnished', 'Partly Furnished', 'Unfurnished', 'Unknown'],
        // for: ['Buy', 'Rent'],
        // forProject: ['Buy'],
        // sizeMeasureCodes: ['Square Feet', 'Square Meters', 'Acres', 'Hectare', 'Unknown'],
        titleTypes: ['Individual', 'Strata', 'Unknown'],
        landTitleTypes: ['Agricultural', 'Commercial', 'Industrial', 'Residential', 'Unknown'],
        directions: ['North', 'North East', 'East', 'South East', 'South', 'South West', 'West', 'North West', 'Unknown'],
        occupies: ['Owner Occupied', 'Tenanted', 'Vacant', 'Unknown'],
        beds: ['Studio', '1', '1+1', '1+2', '2', '2+1', '2+2', '3', '3+1', '3+2', '4', '4+1', '4+2', '5', '5+1', '5+2', '6', '6+', '6+1', '7',
            '7+', '7+1', '8', '8+', '8+1', '9', '9+', '9+1', '10', '10+', '10+1', '11', '11+', '11+1', '12', '12+', '12+1', '13', '13+',
            '13+1', '14', '14+', '14+1', '15', '15+1', '16', '16+', '17', '17+', '18', '18+', '19', '20 Above'],
        facilities: ['BBQ', 'Business Centre', 'Club House', 'Parking', 'Gymnasium', 'Jacuzzi', 'Jogging Track', 'Mini Market', 'Nursery', 'Playground',
            'Salon', 'Sauna', 'Squash Court', 'Swimming Pool', 'Wading Pool', 'Tennis Court', '24hr Security', 'Cafeteria'
        ],
        // propertyListing: [
        //     { label: 'Subsale', value: 'Subsale' },
        //     { label: 'New(Developer Unit)', value: 'Projects' }
        // ],
        rentType: ["Entire Place", "Room Only"],
        defaultImgUrl: "https://iprofstore.blob.core.windows.net/properties/default.jpg"
    },
    // files: {
    //     apiKey: "VBKV2rL8uDSLzMBsnDGRus5ZTe9M75rDgZr8fMRmgzHsX9uapZDG4jjM94q7JrmQ"
    // },
    trrCompany: "The Roof Realty",
    sortColumn: {
        propertySort: [
            { label: "Last Updated Date (latest to oldest)", value: "accendingDate" },
            { label: "Last Updated Date (oldest to latest)", value: "decendingDate" },
            { label: "Price (high to low)", value: "decendingPrice" },
            { label: "Price (low to high)", value: "accendingPrice" },
        ],
        allPropertySort: [
            { label: "Last Updated Date (latest to oldest)", value: "accendingDate" },
            { label: "Last Updated Date (oldest to latest)", value: "decendingDate" },
        ],
        archivedSort: [
            { label: "Last Archived Date (latest to oldest)", value: "accendingDate" },
            { label: "Last Archived Date (oldest to latest)", value: "decendingDate" },
            { label: "Price (high to low)", value: "decendingPrice" },
            { label: "Price (low to high)", value: "accendingPrice" },
        ],
        allArchivedSort: [
            { label: "Last Archived Date (latest to oldest)", value: "accendingDate" },
            { label: "Last Archived Date (oldest to latest)", value: "decendingDate" },
        ],
        groupListingSort: [
            { label: "Latest Created Listing", value: "accendingDate" },
            { label: "Price (high to low)", value: "decendingPrice" },
            { label: "Price (low to high)", value: "accendingPrice" },
        ],
        allGroupListingSort: [
            { label: "Latest Created Listing", value: "accendingDate" }
        ],
    },
    //Property page start
    propertyPageFilter: {
        propertyTypes: [ //originally is property.for
            { label: "For Sale", value: "Buy" },
            { label: "For Rent", value: "Rent" },
            { label: "New (Developer Unit)", value: "New" }, //originally is property.propertyListing
        ],
        propertyStatus: [ //originally is searchStatus.property
            { label: "Active", value: "Active" },
            { label: "Inactive", value: "Inactive" },
            { label: "Archived", value: "Archived" },
            { label: "Outdated", value: "Outdated" },
        ],
    },
    grouplistingPageFilter: {
        propertyFor: [
            { label: 'For Sale & Rent', value: '' },
            { label: 'Sale Only', value: 'Buy' },
            { label: 'Rent Only', value: 'Rent' }
        ],
        status: [
            { label: 'Active Only', value: 'active' },
            { label: 'Inactive Only', value: 'inactive' }
        ],
        categoryListing: [
            { label: 'Listing Category', value: '' },
            { label: 'Commercial', value: 'Commercial' },
            { label: 'Residential', value: 'Residential' }
        ],
        title: [
            { label: 'Property Category', value: '' },
            { label: 'Apartment/Flat', value: 'Apartment/Flat' },
            { label: 'Condo/Serviced Residence', value: 'Condo/Serviced Residence' },
            { label: 'Terrace/Link/Townhouse', value: 'Terrace/Link/Townhouse' },
            { label: 'Semi-D/Bungalow', value: 'Semi-D/Bungalow' },
        ],
        createdAt: [
            { label: 'Last Created', value: '' },
            { label: 'Within 60 days', value: '60' },
            { label: 'Within 90 days', value: '90' },
            { label: 'Over 90 days', value: '>90' },
        ]
    },
    outdatedPropertyUpdateDropdown: [
        { label: "Set as Active", value: "Active" },
        { label: "Set as Inactive", value: "Inactive" },
    ],
    //property page end
    listingCategoryOptions: [{
        categoryListing: "Residential",
        titles: [
            {
                "title": "Apartment/Flat",
                "showPropertyMaster": true,
                "type": ["Apartment", "Flat"]
            },
            {
                "title": "Condo/Serviced Residence",
                "showPropertyMaster": true,
                "type": ["Condominium", "Serviced Residence"]
            },
            {
                "title": "Terrace/Link/Townhouse",
                "showPropertyMaster": false,
                "type": [
                    "1-sty Terrace/Link House",
                    "1.5-sty Terrace/Link House",
                    "2-sty Terrace/Link House",
                    "2.5-sty Terrace/Link House",
                    "3-sty Terrace/Link House",
                    "3.5-sty Terrace/Link House",
                    "4-sty Terrace/Link House",
                    "4.5-sty Terrace/Link House",
                    "2-sty Superlink House",
                    "3-sty Superlink House",
                    "Townhouse"
                ]
            },
            {
                "title": "Semi-D/Bungalow",
                "showPropertyMaster": false,
                "type": [
                    "Cluster House",
                    "Bungalow",
                    "Bungalow Land",
                    "Semi-detached House",
                    "Villa",
                    "3 Storey Semi-detached Homes"
                ]
            },
        ]
    },
    {
        categoryListing: "Commercial",
        titles: [
            {
                "title": "Shop/Office/Retail Space",
                "showPropertyMaster": false,
                "type": [
                    "Office",
                    "Shop",
                    "Shop Office",
                    "Retail Office",
                    "Retail Space",
                    "SOFO",
                    "SOHO",
                    "SOVO",
                    "Commercial Bungalow",
                    "Commercial Semi-D",
                    "Designer Suites",
                    "Business Center"
                ]
            },
            {
                "title": "Hotel/Resort",
                "showPropertyMaster": false,
                "type": ["Hotel/Resort"]
            },
            {
                "title": "Suites",
                "showPropertyMaster": false,
                "type": ["Suites"]
            },
            {
                "title": "Luxury Suites",
                "showPropertyMaster": false,
                "type": ["Luxury Suites"]
            },
        ]
    },
    {
        categoryListing: "Land",
        titles: [
            {
                "title": "Agricultural Land",
                "showPropertyMaster": false,
                "type": ["Agricultural Land"]
            },
            {
                "title": "Commercial Land",
                "showPropertyMaster": false,
                "type": ["Commercial Land"]
            },
            {
                "title": "Residential Land",
                "showPropertyMaster": false,
                "type": ["Residential Land"]
            },

            {
                "title": "Industrial Land",
                "showPropertyMaster": false,
                "type": ["Industrial Land"]
            },
        ]
    },
    {
        categoryListing: "Industrial",
        titles: [
            {
                "title": "Factory/Warehouse",
                "showPropertyMaster": false,
                "type": [
                    "Factory",
                    "Semi-D Factory",
                    "Detached Factory",
                    "Link Factory",
                    "Warehouse",
                    "Light Industrial"
                ]
            }
        ]
    }],
    // image
    mapAgentImage: {
        width: 120,
        height: 120,
        offlineOpacity: 0.5
    },
    profile: {
        imgURL: "https://iprofstore.blob.core.windows.net/general/agentDefault.png"
    },
    // role
    role: ["REN", "PEA", "REA"],
    //payment history
    paymentHistory: {
        statusOpts: [
            { label: "All Status", value: "" },
            { label: "Pending", value: "Pending" },
            { label: "Success", value: "Success" },
            { label: "Failed", value: "Failed" },
        ]
    },
    packageTags: {
        free: ["free", "campaign", "trial"], //free package
        bestDeal: ["essential", "pro", "proplus"], //eligible best deal package
    },
    postingAgents: [ // testing agent for erp213 posting features
        '5e5e0545ca612e08545b0e2e', // Wilson
        // '5e69ed25ca612e08545b0e3b', // Cayden
        '5a950f5d4b8b55198c0f9339', // Cheow Chee Hon
        '6593e8a752b9d3359c458367', // Hee Chai Fung
        '5fab4a27729d71260cbee2ee', // Teow Ruo Ting
        '5a4f182d6397261bf8d053de', // Ng Kooi Foong
        '5ee1aa179602e6358871d65b', // Sim Goik Loo
        '5c6394451379d60570a6c50a', // Lim Yu Chee
        '5d384cda4a75ef1348767b7d', // Tan Kian Leap
        '5e4de83ca24cef2498842d2b', // Lee Kah Hwee
        '5a536729ee3fc81a90f998cc', // Soe Wei Jenn
    ],
    propertyImport: [
        { label: "Import from iProperty", value: "iproperty" },
        { label: "Import from PropertyGuru", value: "propertyguru" },
        { label: "Import from EdgeProp", value: "edgeprop" },
        { label: "Import from Mudah", value: "mudah" },
        // { label: "Account Configuration", value: "integration-platform" },
    ],
    propertyViewLog: [
        { label: "View iProperty log", value: "iproperty" },
        { label: "View PropertyGuru log", value: "propertyguru" },
        { label: "View EdgeProp log", value: "edgeprop" },
        { label: "View Mudah log", value: "mudah" },
    ],
    postingPlatforms: ["IProperty", "PropertyGuru", "EdgeProp", "Mudah"],
}

export default SetupData;